import { RpcSuccess } from '@dealroadshow/json-rpc-dispatcher';
import { inject, injectable } from 'inversify';
import Request from '@framework/api/Rpc/Request';
import withCache from '@framework/with-cache';
import { type IDispatcher } from '@dm-portal/json-rpc-dispatcher';
import DITypes from '@dm-portal/dm-portal-json-rpc-dispatcher/DITypes';

@injectable()
class IndustryRepository {
  constructor(@inject(DITypes.JsonRpcDispatcher) private rpc: IDispatcher) {}

  @withCache
  async list() {
    const req = new Request('dm_portal.market.industry.get_industries');
    const response = await this.rpc.call<RpcSuccess>(req);

    return response.getResult().payload;
  }
}

export default IndustryRepository;
